import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import { getSituationsApiCrud, type GetSituationsRequest } from "@/generated/fastapi";

export async function getSituations(
  accessToken: string | null | undefined,
  request: GetSituationsRequest = {},
) {
  const response = await getSituationsApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200) {
    throw new Error(`Failed to retrieve situations (${response.status})`);
  }

  return response.data ?? [];
}
